import compact from 'lodash/compact';

export const arrayFromDelimitedString = (string, delimiter = ',') => compact((string || '').split(delimiter));
